'use client';

import type { ChainId, MarketId } from '@morpho-org/blue-sdk';
import { useTrackFixedRateCalloutViewed } from '@/lib/analytics/client/hooks/useTrackFixedRateCalloutViewed';

/**
 * Renders nothing; fires the callout's impression. Mounted outside
 * `MarketPageLayout` so the desktop/mobile branch swap doesn't remount it.
 */
export default function MarketFixedRateCalloutImpression(t0) {
  const {
    chainId,
    marketId
  } = t0;
  useTrackFixedRateCalloutViewed(chainId, marketId);
  return null;
}